import { PlusIcon } from 'assets/icons';
import { Breakpoints } from 'common/enums';
import CypressIds from 'cypressIds';
import { trackCustomEvent } from 'helpers/analytics';
import { useMediaQuery } from 'hooks/use-media-query';
import { goToPage, RouteName } from 'routes';
import styles from './new-vault-button.module.scss';

const handleNewVault = () => {
  goToPage(RouteName.VaultNew);
  trackCustomEvent('startVaultCreation', { step: 'home' });
};

export const NewVaultButton = () => {
  const isSmallScreen = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);

  return (
    <button
      type="button"
      className={styles.button}
      onClick={handleNewVault}
      data-cy={CypressIds.newVaultButton}
    >
      {isSmallScreen ? 'New' : 'New Vault'}
      <PlusIcon />
    </button>
  );
};
